import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Button from "../../components/common/Button";
import Logo from "../../assets/img/logos/seva_haat_full_logo.png";
import earn_with_us from "../../assets/img/logos/earn_with_us_logo.png"
import { LOGOUT_STATUS_SUCCESS } from "../../store/actions/loginActions";
import "../../assets/scss/header.scss";

function Header() {
  const token = useSelector(state => state?.LoginReducer?.userLoginDetails?.token ?? null)
  const dispatch = useDispatch()
  const handleclick = () => {
    localStorage.removeItem("vendorToken");
    dispatch({ type: LOGOUT_STATUS_SUCCESS })
  };

  return (
    <header>
    <div className="cmyLogo">
    <a href={"https://vikramshilaedu.in/"} ><img src={Logo}  alt="#" /></a>
    </div>

    <div className="earnLogo">
      <img src={earn_with_us} alt="#" />
    </div>
  </header>
  );
}

export default Header;
